module.exports = __webpack_public_path__ + "static/media/card-background.13d1751d.png";